import { WorkflowData } from '@common/hooks/types';
import { v4 as uuidv4 } from 'uuid';

export const loadTemplate = (
  template: any,
  workflow_id: string,
  name: string,
  username: string | null
): WorkflowData | null => {
  if (!template) return null;

  if (template.flow_id) delete template.flow_id;
  if (template.name) delete template.name;

  template.flow.flow_id = workflow_id;
  template.flow.service_path = workflow_id;
  template.flow.name = name;

  if (username) template.flow.created_by = username;
  if (username) template.flow.updated_by = username;

  // fix the attributes and the output of the nodes
  template.nodes = template.nodes.map((node: any) => {
    let attributes = node.attributes;
    if (typeof attributes === 'string') {
      attributes = JSON.parse(attributes);
    }

    let output = node.output;
    if (typeof output === 'string') {
      output = JSON.parse(output);
    }

    const positionx = node?.position?.x;
    const positiony = node?.position?.y;

    delete node.position;

    return {
      ...node,
      attributes,
      output,
      positionx,
      positiony,
    };
  });

  template.edges = template.edges.map((edge: any) => ({
    ...edge,
    id: uuidv4(),
  }));

  return template;
};
